import React, { useEffect, useState } from "react";
import api from "../../services/api";

const PrivateMedia = ({ mediaUrl, children }) => {
  const [objectUrl, setObjectUrl] = useState(null);

  useEffect(() => {
    let cancelled = false;
    let createdUrl = null;

    const load = async () => {
      try {
        const parsed = new URL(mediaUrl);
        const filename = parsed.pathname.split("/").pop();

        if (
          !filename ||
          !parsed.pathname.startsWith("/public/")
        ) {
          return;
        }

        const response = await api.get(
          `/private-media/${encodeURIComponent(filename)}`,
          { responseType: "blob" }
        );

        if (cancelled) return;

        createdUrl = URL.createObjectURL(response.data);
        setObjectUrl(createdUrl);
      } catch (error) {
        console.error("No se pudo cargar el archivo privado");
      }
    };

    if (mediaUrl) load();

    return () => {
      cancelled = true;
      if (createdUrl) URL.revokeObjectURL(createdUrl);
    };
  }, [mediaUrl]);

  if (!objectUrl) return null;

  return children(objectUrl);
};

export default PrivateMedia;
